var map = {
	"./D4024.png": "c5bb",
	"./D4101.png": "b8e7",
	"./D4103.png": "8956",
	"./D4104_.png": "c553",
	"./amgo.png": "ff23",
	"./amgo_sgp.png": "9bf4",
	"./amgo_third.png": "9922",
	"./amigo_vi.png": "0249",
	"./amigo_vi_login.png": "1f73",
	"./copy.png": "84a5",
	"./ftp.png": "0910",
	"./ftp_test.png": "64be",
	"./icon_dark.png": "b39c",
	"./icon_light.png": "c3e2",
	"./myntra.png": "3768",
	"./myntra_test.png": "aa51",
	"./order.png": "9a66",
	"./shopee.png": "4f52",
	"./test.png": "5f12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb1a";